import CityHallRegistration from './CityHallRegistration';

export default CityHallRegistration;